<template>
  <div class="fun-left-wrap">
    <div
      class="show-left-btn fun-left-wrap-put"
      @click="showLeftList = true"
      v-show="!showLeftList"
    >
      <span style="background: #2db7f5" data-key="1" @click="changeTab"
        >待接诊</span
      >
      <span style="background: #ff9900" data-key="2" @click="changeTab"
        >就诊中</span
      >
      <span style="background: #ed4014" data-key="3" @click="changeTab"
        >已结诊</span
      >
    </div>
    <!-- 曹妃甸诊所开方 -->
    <div
      class="show-left-btn fun-left-wrap-put fun-left-Treatment"
      @click="showTreatmentList = true"
      v-show="!showTreatmentList && userInfo.hospital.includes('曹妃甸')"
    >
      <span style="background: #ad4c34ca" @click="getTreatmentList"
        >诊所开方</span
      >
    </div>

    <div class="fun-left-wrap-list" v-show="showLeftList">
      <p class="fun-left-wrap-title">
        <Icon
          type="ios-arrow-dropleft"
          class="fun-left-wrap-put"
          @click="showLeftList = false"
        />诊疗列表
      </p>
      <div class="search-info">
        <!-- <div class="name">患者</div> -->
        <Input
          v-model="patientKey"
          class="input"
          placeholder="就诊卡号或姓名"
          clearable
        />
        <div class="btn" type="info" @click="search">搜索</div>
      </div>
      <div class="search-date">
        <!-- <div class="name">日期</div> -->
        <DatePicker
          :split-panels="true"
          @on-change="handleChange"
          :value="dateValue"
          type="daterange"
          placement="bottom-end"
          :options="optionsDate"
          placeholder="请选择日期"
        ></DatePicker>
      </div>
      <div class="seek-person">
        <div>待接诊：{{ perList.waitNum }}位</div>
        <div>已接诊：{{ perList.ingNum }}位</div>
        <div>已结诊：{{ perList.finishNum }}位</div>
      </div>
      <div class="seek-tab" @click="changeTab">
        <div
          v-for="(item, index) in tabColumns"
          :key="index"
          :data-key="item.key"
          :class="item.key == checkedTagType ? 'checked-tab' : ''"
        >
          {{ item.value }}
        </div>
      </div>
      <Scroll
        :on-reach-bottom="handleReachTop"
        height="500"
        class="scrollWrap"
        :loading-text="loadingTxt"
      >
        <div id="list-wrap-id" class="list-wrap">
          <div
            v-for="(item, index) in personInfoList"
            :key="index"
            class="item-info"
            :class="{ active: item.orderId == headerUserRest.orderId }"
            @click="changePersonInfo(index)"
          >
            <div class="name">{{ item.patientName }} ({{ item.cardId }})</div>
            <div class="other-info">
              <div>
                <span
                  >性别：<span
                    :class="
                      item.orderId == headerUserRest.orderId ? '' : 'value'
                    "
                    >{{ item.sex }}</span
                  ></span
                >&nbsp;
                <span
                  >年龄：<span :class="item.checked ? '' : 'value'">{{
                    item.age
                  }}</span></span
                >&nbsp;
                <!-- <p class="status" v-if=" this.$store.state.prvateConsultation.headerUserRest.status === 1">待接诊</p> -->
                <span
                  >问诊方式：
                  <span
                    :class="item.checked ? '' : 'value'"
                    v-if="item.inquiryType === 0"
                    >图文问诊</span
                  >
                  <span
                    :class="item.checked ? '' : 'value'"
                    v-if="item.inquiryType === 1"
                    >电话问诊</span
                  >
                  <span
                    :class="item.checked ? '' : 'value'"
                    v-if="item.inquiryType === 2"
                    >视频问诊</span
                  >
                </span>
              </div>
              <div>
                <span
                  >预约日期：<span :class="item.checked ? '' : 'value'">{{
                    item.time
                  }}</span></span
                >&nbsp;
                <span v-if="item.timeSlot"
                  >时间段：<span :class="item.checked ? '' : 'value'">{{
                    item.timeSlot
                  }}</span></span
                >
              </div>
            </div>
          </div>
          <div>&nbsp;</div>
        </div>
      </Scroll>
    </div>

    <!-- 曹妃甸诊所开方 -->
    <div
      class="fun-left-wrap-list TreatmentListWrap"
      v-show="showTreatmentList"
    >
      <p class="fun-left-wrap-title">
        <Icon
          type="ios-arrow-dropleft"
          class="fun-left-wrap-put"
          @click="showTreatmentList = false"
        />诊所开方
      </p>
      <div class="search-info">
        <Input
          v-model="testId"
          class="input"
          placeholder="扫码检测ID"
          clearable
        />
        <div class="btn" type="info" @click="getPatientByTestId">搜索</div>
      </div>
      <Scroll
        :on-reach-bottom="handleReachTop2"
        height="500"
        class="scrollWrap"
        :loading-text="loadingTxt2"
      >
        <div class="list-wrap">
          <div
            v-for="(item, index) in InitiateTreatmentPersonInfoList"
            :key="index"
            class="item-info"
            @click="changePersonInfo(index, true)"
          >
            <div class="name">{{ item.name }} ({{ item.cardId }})</div>
            <div class="other-info">
              <div>
                <span>性别：</span><span>{{ item.gender }}</span
                >&nbsp; <span>年龄：</span><span>{{ item.age }}</span
                >&nbsp;
                <span class="bbtn" @click="InitiateTreatmentHand(item)"
                  >我要开方</span
                >
              </div>
            </div>
            <div class="other-info">
              <div>
                <span
                  >身份证号：<span>{{ item.idCard }}</span></span
                >&nbsp;
              </div>
              <div>
                <span
                  ><span>{{ item.createTime }}</span></span
                >&nbsp;
                <span
                  class="bbtn"
                  @click="InitiateTreatmentHandOnlineDiagnoseList(item)"
                  >开方记录</span
                >
              </div>
            </div>
          </div>
          <div>&nbsp;</div>
        </div>
      </Scroll>
      <div
        class="list-wrap initiateHistoryListWrap"
        v-if="initiateHistoryListShow"
      >
        <p class="fun-left-wrap-title">
          <Icon
            type="ios-arrow-dropleft"
            class="fun-left-wrap-put"
            @click="initiateHistoryListShow = false"
          />开方记录
        </p>
        <div
          v-for="(item, index) in initiateHistoryList"
          :key="index"
          class="item-info"
          @click="InitiateChangePersonInfo(item)"
        >
          <div class="name">
            {{ item.patientName }} &nbsp;{{ item.fromDepartment }}&nbsp;{{
              item.statusText
            }}
          </div>
          <div class="other-info">
            <div>
              <span>性别：</span><span>{{ item.sex }}</span
              >&nbsp; <span>年龄：</span><span>{{ item.age }}</span
              >&nbsp;
            </div>
          </div>
          <div class="other-info">
            <div>
              <span
                ><span>{{ item.time }}</span></span
              >&nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '@/services'

import { fmtDate, EventBus, debounce } from '@/utils/tool'
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      showLeftList: true,
      showTreatmentList: false,
      patientKey: '',
      total: '',
      searchParams: {
        status: 1,
        pageNum: 1,
        pageSize: 10
      },
      InitiateTreatmentParams: {
        pageIndex: 1,
        pageSize: 10
      },
      initiateHistoryListShow: false,
      initiateHistoryList: [],
      testId: '',
      dateValue: [],
      optionsDate: {
        //   disabledDate: function(date){
        //     return date.getTime() > Date.now()
        //   }
      },
      tabColumns: [
        {
          value: '待接诊',
          key: 1
        },
        {
          value: '已接诊',
          key: 2
        },
        {
          value: '已结诊',
          key: 3
        },
        {
          value: '未结诊',
          key: 4
        }
      ],
      keyOfPage: 1,
      waitNum: '',
      ingNum: '',
      finishNum: '',
      pageNumD: 0,
      loadingTxt: '加载中',
      loadingTxt2: '加载中'
    }
  },

  mounted () {
    //   点击结诊后 左侧菜单变化
    EventBus.$on('incremented', (status) => {
      this.keyOfPage = status
      this.cleanObj()
      this.searchParams.pageNum = 0
      this.changePersonList()
    })
  },
  created: function () {
    this.dateInte()
    this.search()
  },
  computed: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest',
      showIMStore: 'prvateConsultation/showIM',
      showIMTime: 'prvateConsultation/showIMTime',
      orderStatus: 'prvateConsultation/orderStatus',
      userInfo: 'auth/info',
      checkedTagType: 'prvateConsultation/checkedTagType',
      perList: 'prvateConsultation/perList',
      personInfoList: 'prvateConsultation/personInfoList',
      InitiateTreatmentPersonInfoList: 'InitiateTreatment/personInfoList'
    })
  },
  methods: {
    ...mapActions({
      fetchOnlineDiagnoseList: 'prvateConsultation/fetchOnlineDiagnoseList',
      getDoctorInitiateTreatmentList: 'InitiateTreatment/getDoctorInitiateTreatmentList'
    }),
    // 无限加载分页
    handleReachTop (dir) {
      // $0.scrollHeight - $0.clientHeight - $0.scrollTop
      if (this.perList.array.length < this.searchParams.pageSize) {
        this.loadingTxt = '已经到头了'
        return false
      }
      return new Promise(resolve => {
        ++this.searchParams.pageNum
        this.$store.commit('prvateConsultation/setPaginationPerson', this.searchParams)
        this.changePersonList()
        resolve()
      })
    },
    handleReachTop2 (dir) {
      // $0.scrollHeight - $0.clientHeight - $0.scrollTop
      if (this.InitiateTreatmentPersonInfoList.length < this.InitiateTreatmentParams.pageSize) {
        this.loadingTxt2 = '已经到头了'
        return false
      }
      return new Promise(resolve => {
        ++this.InitiateTreatmentParams.pageIndex
        this.$store.commit('InitiateTreatment/setPagination', this.InitiateTreatmentParams)
        this.getDoctorInitiateTreatmentList()
        resolve()
      })
    },
    search (e) {
      // 判断是不是按钮点击
      if (e) {
        if (this.patientKey == '') {
          this.$Message.warning('请输入就诊卡或者姓名')
          return
        }
        this.searchParams.patientKey = this.patientKey
      } else {
        this.$delete(this.searchParams, 'patientKey')
      }
      this.searchParams.pageNum = 0
      this.changePersonList()
    },
    async changePersonList () {
      this.searchParams.status = this.keyOfPage
      var params = this.searchParams
      this.$store.commit('prvateConsultation/setPaginationPerson', params)
      await this.fetchOnlineDiagnoseList(params)
      this.renderPage()
    },
    renderPage () {
      this.changeListAttr(0)

      if (this.searchParams.status == 1) {
        this.$store.commit('prvateConsultation/setCheckedTagKey', 1)
      }
      this.$store.commit(
        'prvateConsultation/setcheckedTagType',
        this.searchParams.status
      )
    },
    handleChange (date) {
      if (date[0] && date[1]) {
        // 处理时间范围最多一年
        let btime =
          new Date(date[1]).getTime() - new Date(date[0]).getTime() >
          3600 * 1000 * 24 * 365
        if (btime) {
          let yester = date[1].split('-')
          yester[0] = date[1].split('-')[0] - 1
          yester = yester.join('-')
          this.searchParams.timeFrom = yester
          this.searchParams.timeTo = date[1]
          this.dateValue = [yester, date[1]]
        } else {
          this.searchParams.timeFrom = date[0]
          this.searchParams.timeTo = date[1]
        }
        console.log(
          new Date(fmtDate(new Date(date[1]).getTime(), 'yyyy-MM-dd'))
        )
      } else {
        this.searchParams.timeFrom = fmtDate(new Date().getTime(), 'yyyy-MM-dd')
        this.searchParams.timeTo = fmtDate(new Date().getTime(), 'yyyy-MM-dd')
        // this.$delete(this.searchParams, 'timeFrom')
        // this.$delete(this.searchParams, 'timeTo')
      }
      this.search()
    },
    changeTab (e) {
      console.log(e)
      this.keyOfPage = e.target.dataset.key
      this.cleanObj()
      this.searchParams.pageNum = 0
      this.changePersonList()
      if (document.querySelector('.ivu-scroll-container')) {
        document.querySelector('.ivu-scroll-container').style.height = document.querySelector('.ivu-scroll-wrapper').clientHeight + 'px'
      }
    },
    async getTreatmentList () {
      var params = this.InitiateTreatmentParams
      this.$store.commit('InitiateTreatment/setPagination', params)
      this.testId = ''
      await this.getDoctorInitiateTreatmentList(params)
    },
    InitiateTreatmentHand (item) {
      var self = this
      api.doctorInitiateTreatment({
        data: {
          params: {
            cardId: item.cardId
          }
        }
      }).then(async (res) => {
        if (res.code === 0) {
          var obj = {
            ...item,
            sex: item.gender,
            patientName: item.name,
            time: item.createTime,
            status: 2,
            orderId: res.data.orderId
          }
          this.$store.commit('prvateConsultation/setcheckedTagType', 2)
          this.$store.commit('prvateConsultation/setCheckedTagKey', 2)
          this.$store.commit('prvateConsultation/setHeaderUserRest', obj)
          // await self.changeTab ({target:{dataset:{key:2}}})
          // setTimeout(()=>{
          // var index = self.personInfoList.findIndex(item=>item.orderId === res.data.orderId)
          // self.$store.commit('prvateConsultation/setCheckedTagKey', 2)
          // self.showTreatmentList = false
          // if(index !=-1){
          //   self.changePersonInfo (index)
          //   self.showLeftList = false
          // }else{
          //   self.showLeftList = true
          // }
          // },1000)
        }
      })
    },
    InitiateChangePersonInfo (item) {
      let status = 4
      if (item.status == 2) {
        status = 1
      } else if (item.status == 3) {
        status = 2
      } else if (item.status == 4) {
        status = 3
      }
      var obj = {
        ...item,
        status: status
      }
      this.$store.commit('prvateConsultation/setcheckedTagType', status)
      this.$store.commit('prvateConsultation/setCheckedTagKey', 2)
      this.$store.commit('prvateConsultation/setHeaderUserRest', obj)
      this.$store.commit('prvateConsultation/setNoGetReserveInfo', false)
      this.initiateHistoryListShow = false
      this.showTreatmentList = false
    },
    InitiateTreatmentHandOnlineDiagnoseList (item) {
      this.initiateHistoryList = []
      api.onlineDiagnoseList({
        data: {
          params: {
            patientGuid: item.patientGuid
          }
        }
      }).then(res => {
        if (res.code === 0) {
          this.initiateHistoryListShow = true
          this.initiateHistoryList = res.data.array
        }
      })
    },
    getPatientByTestId: debounce(function () {
      if (this.testId == '') {
        return false;
      }
      api.getPatientByTestId({
        data: {
          params: {
            testId: this.testId
          }
        }
      }).then(res => {
        if (res.code === 0) {
          this.$store.commit('InitiateTreatment/FETCH_LIST_SUCCESS', {
            data: { list: [{ ...res.data, time: new Date(fmtDate(new Date().getTime())) }] },
            pagination: {
              pageIndex: 1,
            }
          })
          // this.getTreatmentList()
          this.testId = ''
        }
      }).catch(error => {
        this.testId = ''
        console.log(error)
      })
    }, 1000),
    changePersonInfo (index, no) {
      if (no) {
        this.$store.commit('prvateConsultation/setNoGetReserveInfo', false)
      } else {
        this.$store.commit('prvateConsultation/setNoGetReserveInfo', true)
      }
      this.changeListAttr(index)
    },
    changeListAttr (key = 0, type) {
      // this.$store.commit('prvateConsultation/setHeaderUserRest', this.personInfoList.array[key])
      this.personInfoList.map((item, i) => {
        if (key === i) {
          item.checked = true

          this.$store.commit('prvateConsultation/setHeaderUserRest', item)
          this.getDiagnoseApplyDetail(item)
        } else {
          item.checked = false
        }
      })
      // debugger
      // this.$store.commit('prvateConsultation/setPersonInfoList', personInfoListState)
    },
    getDiagnoseApplyDetail (item) {
      api.diagnoseApplyDetail({
        data: {
          params: {
            orderId: item.orderId
          }
        }
      }).then(res => {
        if (res.code === 0) {
          console.log(res.data.showMedicalTemplate)
          var templateBtns = {
            showMedicalTemplate: res.data.showMedicalTemplate,
            showCheckoutTemplate: res.data.showCheckoutTemplate,
            showExamineTemplate: res.data.showExamineTemplate
          }
          this.$store.commit('prvateConsultation/setBtnShow', {
            templateBtns: templateBtns
          })
        }
      }).catch(error => {

      })
    },
    // 日期初始化
    dateInte () {
      // var localdate = new Date()
      // var yesterday = new Date().getTime() - 24 * 60 * 60 * 1000
      // var tomorrow = new Date().getTime() + 24 * 60 * 60 * 1000
      var today = fmtDate(new Date(), 'yyyy-MM-dd')
      // var yesterday = fmtDate(new Date(yesterday), 'yyyy-MM-dd')
      // var tomorrow = fmtDate(new Date(tomorrow), 'yyyy-MM-dd')
      var dateVal = [today, today]
      this.searchParams.timeFrom = dateVal[0]
      this.searchParams.timeTo = dateVal[1]
      this.dateValue = dateVal
    },
    cleanObj () {
      this.searchParams.pageNum = 1
      // this.personInfoList = []
    }
  },

  watch: {
    'patientKey': function (val) {
      if (val.trim() == '') {
        this.search()
      }
    }
  }
}

</script>

<style lang="scss">
.fun-left-wrap {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 99;
}
.fun-left-wrap-list {
  width: 200px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
  // padding-top: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: 0px 2px 5px 0px rgba(170, 170, 170, 1);
  border-radius: 0px 4px 0px 0px;
  position: relative;
  z-index: 2;
}
.fun-left-wrap-title {
  text-align: center;
  line-height: 1rem;
}
.fun-left-wrap-put {
  position: absolute;
  top: 10px;
  left: 10px;
}
.fun-left-wrap-put {
  cursor: pointer;
}

.show-left-btn {
  position: absolute;
  left: 0;
  top: 20%;
  span {
    display: inline-block;
    color: #fff;
  }
}
.fun-left-Treatment {
  top: 62%;
}
.search-info,
.search-date {
  height: 20px;
  padding: 0 8px 0 7px;
  font-size: 9px;
  font-weight: 400;
  color: rgba(51, 97, 143, 1);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 7px;
  flex: 0 0 auto;
}
.search-date {
  margin-bottom: 6px;
}
.search-info .name {
  margin-right: 6px;
  line-height: 10px;
  white-space: nowrap;
}
.search-info .ivu-input-wrapper {
  width: inherit;
  display: flex;
  align-items: center;
}
.search-info .input .ivu-input {
  width: 140px;
  height: 20px;
  margin-right: 9px;
  border: 1px solid rgba(181, 181, 181, 1);
  border-radius: 0px;
  margin-right: 9px;
  box-sizing: border-box;
  padding-left: 2px;
  font-size: 9px;
  font-weight: 500;
}
.search-info .input .ivu-input:focus {
  outline: none;
  border-color: rgba(114, 190, 255, 1);
  box-shadow: 0 0 2px rgba(114, 190, 255, 1);
}
.search-info .input::-webkit-input-placeholder {
  color: rgba(214, 214, 214, 1);
  font-size: 9px;
}
.search-info .input:focus {
  outline: none;
  border-color: rgba(114, 190, 255, 1);
  box-shadow: 0 0 2px rgba(114, 190, 255, 1);
}
.search-info .btn {
  width: 39px;
  height: 20px;
  font-size: 9px;
  color: #fff;
  line-height: 20px;
  text-align: center;
  background: rgba(114, 190, 255, 1);
  border-radius: 0px;
  cursor: pointer;
}
.search-date .name {
  margin-right: 6px;
  white-space: nowrap;
}
.search-date .ivu-date-picker .ivu-date-picker-rel .ivu-input {
  width: 140px;
  height: 20px;
  padding: 0;
  border: 1px solid rgba(181, 181, 181, 1);
  padding-left: 2px;
  border-radius: 0px;
  font-size: 9px;
  font-weight: 500;
  color: #000;
}
.search-date .ivu-date-picker .ivu-date-picker-rel .ivu-input:focus {
  outline: none;
  border-color: rgba(114, 190, 255, 1);
  box-shadow: 0 0 2px rgba(114, 190, 255, 1);
}
.search-date
  .ivu-date-picker
  .ivu-date-picker-rel
  .ivu-input::-webkit-input-placeholder {
  color: rgba(214, 214, 214, 1);
  font-size: 9px;
}
.search-date .ivu-date-picker .ivu-date-picker-rel .ivu-input-suffix > i {
  width: 30px;
  height: 20px;
  line-height: 20px;
  color: rgba(114, 190, 255, 1);
}
.seek-person {
  padding: 0 14px;
  display: flex;
  justify-content: space-between;
  height: 20px;
  line-height: 20px;
  font-size: 7px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  flex: 0 0 auto;
}
.seek-tab {
  padding-top: 8px;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #72beff;
  border-top: 1px solid #ebebeb;
  margin-bottom: 1px;
  flex: 0 0 auto;
}
.seek-tab > div {
  flex: 1;
  display: inline-block;
  height: 20px;
  white-space: nowrap;
  line-height: 20px;
  text-align: center;
  font-size: 9px;
  font-family: 'MicrosoftYaHei';
  font-weight: 400;
  color: #333333;
  cursor: pointer;
}
.seek-tab > .checked-tab {
  font-weight: 800;
  background: #72beff;
  color: #fff;
  border-radius: 4px 4px 0px 0px;
  box-sizing: border-box;
}
.seek-tab > div.checked-tab:last-child {
  border-radius: 4px 0px 0px 0px;
}
.seek-tab > div.checked-tab:first-child {
  border-radius: 0px 4px 0px 0px;
}
.scrollWrap {
  width: 200px !important;
  box-sizing: border-box;
  .ivu-scroll-container {
    overflow-y: auto;
    height: calc(100vh - 162px) !important;
    .ivu-scroll-loader:first-child {
      display: none;
    }
  }
}
.list-wrap {
  flex: auto;
  overflow-y: auto;
  overflow-x: hidden;
  /* background:rgba(247,247,247,1); */
}
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: #ddd;
}

.list-wrap .item-info {
  width: 100%;
  height: 74px;
  background: #fff;
  padding: 13px 0 17px 9px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(214, 214, 214, 1);
  cursor: pointer;
  font-family: 'MicrosoftYaHei';
}
.list-wrap .item-info .name {
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  white-space: nowrap;
  margin-bottom: 11px;
}
.list-wrap .item-info .other-info {
  height: 22px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 9px;
  color: rgba(102, 102, 102, 1);
  line-height: 9px;
}
.other-info .value {
  color: #000;
  font-weight: 500;
}
.list-wrap .item-info.active {
  background: #72beff;
  color: #fff;
  .name,
  .other-info,
  .value {
    color: #fff;
  }
}

.TreatmentListWrap {
  position: relative;
  .item-info {
    height: 94px;
    .bbtn {
      border: 1px solid #09bb07;
      color: #09bb07;
      padding: 2px;
      border-radius: 2px;
      float: right;
      margin-right: 10px;
    }
  }
  .initiateHistoryListWrap {
    background-color: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_left/index.vue